document.addEventListener('DOMContentLoaded', function () {

    var toc = document.getElementById('toc');
    var headers = document.querySelectorAll(window.linklistTitleToc); // Adjust as needed

    headers.forEach(function (header) {
        if (!header.id) {
            header.id = header.textContent.trim().toLowerCase().replace(/\s+/g, '-').replace(/\+/g, '-'); // Replace spaces and + with -
        }
        var anchor = document.createElement('a');
        anchor.href = '#' + header.id;
        anchor.textContent = header.textContent;
        toc.appendChild(anchor);
    });

    // Smooth scrolling functionality
    document.querySelectorAll('.toc-container a').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    let screen_width = $(window).width();

    $(window).scroll(function(){
        if (screen_width > 850) {
            if ($(window).scrollTop() >= '120') {
                $(".toc-container").css({"margin-top": "40px"});
            } else {
                $(".toc-container").css({"margin-top": "60px"});
            }
        } else {
            if ($(window).scrollTop() >= '120') {
                $(".toc-container").css({"margin-top": "22px"});
            } else {
                $(".toc-container").css({"margin-top": "10px"});
            }
        }
    });

    document.querySelectorAll('.toc-container a').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            var targetElement = document.querySelector(this.getAttribute('href'));
            var offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        });
    });

});